module.exports = __webpack_public_path__ + "5a40c372c5979bdb162f76c01957c4a5.svg";